export const EMAIL_ACCOUNT_TYPE_KEY = 'account_type'

export const EMAIL_INFO_ACCOUNT = 'info'

export const EMAIL_SERVICE_ACCOUNT = 'service'

export const EMAIL_NYLAS_TYPE = 'nylas'

export const EMAIL_NYLAS_V3_TYPE = 'nylas_v3'

export const EMAIL_AVAILABLE_ACCOUNT_TYPES = [
  EMAIL_NYLAS_TYPE,
  EMAIL_NYLAS_V3_TYPE,
]

export const EMAILS_DRAFT_PREFIX = 'emails'

export const EMAIL_SYSTEM_ACCOUNT_ID = 0

export const SERVICE_REQUEST_EMAILS_DRAFT_PREFIX =
  'service-request-profile-emails'

export const SERVICE_REQUEST_ACTIVITIES_DRAFT_PREFIX =
  'service-request-profile-activities'

export const EMAIL_REPLY_FORM_HTML_BLOCK_ID = 'reply'

export const EMAIL_REPLY_FORM_HTML_QUOTED_HISTORY_CLASSNAME = 'quoted-history'
